import { render } from "./Navbar.vue?vue&type=template&id=17e2fa52&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=17e2fa52&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-17e2fa52"

export default script